import React, { useState } from 'react'
import "./SendTestMessageActionBanner.scss";
import sendTestMEssageIcon from '../../../../../../assets/svg/send-test-message-icon.svg';
import SendTestMessageModal from './SendTestMessageModal';

export const QA_ID_PREFIX = "SendTestMessageActionBanner";

function SendTestMessageActionBanner() {

  const [open, setOpen] = useState(false);

  return (
    <>
    <div
      className="send-test-message-action-banner"
      data-testid={`${QA_ID_PREFIX}-banner`}
    >
      <div data-testid={`${QA_ID_PREFIX}-icon-wrapper`}>
        <img
          style={{maxWidth: "none"}}
          width={48}
          height={43}
          src={sendTestMEssageIcon}
          alt="Send Test Message"
          data-testid={`${QA_ID_PREFIX}-icon`}
        />
      </div>
      <div data-testid={`${QA_ID_PREFIX}-content`}>
        <h3 data-testid={`${QA_ID_PREFIX}-title`}>Test your message before sending it!</h3>
        <div
          style={{marginTop: "8px"}}
          data-testid={`${QA_ID_PREFIX}-description`}
        >
          Preview your message to check formatting, links, and personalization. Sending a test helps ensure everything looks right and avoids mistakes.
        </div>
        <button
          className='send-test-message-button'
          style={{marginTop: "8px"}}
          onClick={() => setOpen(true)}
          data-testid={`${QA_ID_PREFIX}-button`}
        >
          Send test message
        </button>
      </div>
    </div>
    <SendTestMessageModal
      isOpen={open}
      onClose={() => setOpen(false)}
      id={`${QA_ID_PREFIX}-modal`}
    />
    </>
  )
}

export default SendTestMessageActionBanner